import {
  Download,
  Eye,
  File,
  FileImage,
  FileText,
  LoaderCircle,
} from "lucide-react";
import type { RequirementFile } from "../types/compliance";
import { Badge, Button } from "../components/ui";

interface FileRowProps {
  file: RequirementFile;
  busy: boolean;
  onOpen(download: boolean): void;
}

export function FileRow({ file, busy, onOpen }: FileRowProps) {
  const Icon = file.mimetype?.startsWith("image/")
    ? FileImage
    : file.mimetype === "application/pdf"
    ? FileText
    : File;
  const status =
    file.fgstatus === 2
      ? "Aprovado"
      : file.fgstatus === 3
      ? "Reprovado"
      : file.fgstatus === 4
      ? "Substituído"
      : "Em análise";
  const size =
    file.file_size === null || file.file_size === undefined
      ? null
      : `${(Number(file.file_size) / 1024).toFixed(1)} KB`;

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 bg-white p-3">
      <Icon className="shrink-0 text-slate-500" size={20} />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-slate-900">
          {file.filename}
        </p>
        <p className="text-xs text-slate-500">
          Geração {file.nrgeneration}
          {size ? ` · ${size}` : ""}
          {file.dtupload
            ? ` · enviado em ${new Date(file.dtupload).toLocaleDateString(
                "pt-BR"
              )}`
            : ""}
        </p>
      </div>
      <Badge
        variant="outline"
        className="rounded-full border-slate-200 bg-slate-50 text-slate-600"
      >
        {status}
      </Badge>
      {busy ? (
        <LoaderCircle className="animate-spin text-teal-700" size={18} />
      ) : (
        <div className="flex">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            title="Visualizar"
            onClick={() => onOpen(false)}
          >
            <Eye size={17} />
          </Button>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            title="Baixar"
            onClick={() => onOpen(true)}
          >
            <Download size={17} />
          </Button>
        </div>
      )}
    </div>
  );
}
